import styled from 'styled-components'
import { Table as DefaultTable, FakeLinkButton } from '@sketch/components'

import { ReactComponent as QuestionMark } from '@sketch/icons/circle-question-mark-button-translucent-17'

export const Title = styled.h1`
  margin: 0 0 4px 0;
  font-size: ${({ theme }) => theme.fontSizes.H};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`

export const Description = styled.p`
  margin: 0;
  max-width: 640px;
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const DescriptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px; /* stylelint-disable-line scales/space */
`

export const QuestionMarkIcon = styled(QuestionMark)`
  width: 17px;
  height: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const QuestionMarkLink = styled.a`
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.7;
  }
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`

export const ErrorWrapper = styled.div`
  margin: 64px 0;
`

export const StyledFakeLinkButton = styled(FakeLinkButton)`
  font-size: ${({ theme }) => theme.fontSizes.E};
`

export const Wrapper = styled.div`
  margin-top: 24px;
`

export const Table = styled(DefaultTable)`
  width: 100%;
` as typeof DefaultTable

export const IntegrationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`

export const IntegrationIcon = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border.B};
  border-radius: ${({ theme }) => theme.radii.medium};
  overflow: hidden;
`

export const IntegrationName = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-size: ${({ theme }) => theme.fontSizes.E};
`

export const IntegrationStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ActionCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`
